import React, { useCallback, useContext, useEffect, useState } from 'react';
import type { NextPage } from 'next';
import { PageLayout } from '@/components/pagelay';

import { useRouter } from 'next/router';
import useRequest from '@/utils/useRequest';
import { useTranslations } from 'next-intl';
import Head from 'next/head';

interface IProps {

}

const Default: NextPage<IProps> = ({ }) => {
  const router = useRouter()
  const request = useRequest()
  const [data, setData] = useState<any>()
  const t = useTranslations();

  const getData = useCallback(async () => {
    const { data } = await request.get('/getHomeMenuDetail', {
      params: {
        path: router.asPath,
        lang: router.locale
      }
    })
    setData(data?.data)
  }, [router])

  useEffect(() => {
    getData()
  }, [])

  return (
    <PageLayout temp='page_crumb'>
      <>
        <Head>
          <title>{data?.meta_title || data?.title}</title>
          <meta name="keywords" content={data?.meta_kws} />
          <meta name="description" content={data?.meta_desc} />
        </Head>
        {data?.content_type == 2 ?
          <div style={{ maxWidth: '1400px', margin: 'auto' }} dangerouslySetInnerHTML={{
            __html: data?.content
          }} />
          : <div style={{
            width: '50%',
            margin: 'auto',
            textAlign: 'center',
          }}>
            <p style={{
              fontSize: '24px',
              color: '#6354a2',
              margin: '60px 0',
            }}>{t('common.none')}</p>
          </div>}
      </>

    </PageLayout>
  )
};

export default Default;
